import { useEffect } from 'react'
import { useNavigationAwayContext } from '../components/Context/NavigationAwayContext'

/**
 * Hook to accept a synchronous handler to be called when the history location changes.
 */
export const useNavigationListener = (options: {
  overrideBlock: boolean
  initiateBlock: boolean
  handler: () => void
}): void => {
  const { overrideBlock, initiateBlock, handler } = options
  const {
    setConfirmationModalState,
    isConfirmationModalOpen,
    actionConfirmed,
  } = useNavigationAwayContext()

  const blockHandler = (): boolean => {
    if (overrideBlock) {
      return true
    }
    if (actionConfirmed === undefined && initiateBlock) {
      setConfirmationModalState(true)
      return false
    }
    if (!isConfirmationModalOpen && actionConfirmed !== undefined) {
      setConfirmationModalState(false)
      handler()
      return true
    } else {
      return false
    }
  }

  /**
   * Block attempts to leave the page if data is to be saved https://github.com/remix-run/history/blob/dev/docs/api-reference.md#history.block
   *
   * In this case, we'll manually block if attempting to navigate away.
   */
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const isBlocked = blockHandler()
    // FIXME: Use a blocker with the new react-router
    // const unregister = history.block(isBlocked)
    // return unregister
  })
}
